import { render, staticRenderFns } from "./GroupTeamsBoard.vue?vue&type=template&id=34e01752&"
import script from "./GroupTeamsBoard.vue?vue&type=script&lang=js&"
export * from "./GroupTeamsBoard.vue?vue&type=script&lang=js&"
import style0 from "./GroupTeamsBoard.vue?vue&type=style&index=0&id=34e01752&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports